module.exports = __webpack_public_path__ + "prod/1.42.2/img/qrCode.0890abf3.png";